<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 个人中心 -->
    <div class="user-search">
      <el-card shadow="hover" style="height:550px">
        <h3 class="title_style">个人中心</h3>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          class="demo-ruleForm"
        >
          <div class="up_header">
            <el-upload
              class="avatar-uploader"
              v-model="form.head_img"
              action=""
              :show-file-list="false"
              :http-request="getImgData"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>

          <el-form-item label="账号">
            <el-input v-model="form.account" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">立即修改</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  get_user_one,
  get_user_upload_img,
  get_user_upload,
  get_user_edit,
} from "../../api/user/user";
export default {
  data() {
    return {
      imageUrl: "",
      form: {
        head_img: "",
        name: "",
        account: "",
        phone: "",
        email: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 3, max: 6, message: "长度在 3 到 6 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号，如：176****4239",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "change" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    //个人信息
    getData() {
      get_user_one().then((res) => {
        if (res["code"] === 0) {
          this.form = res.data;
          this.imageUrl = res.data.head_img;
        }
      });
    },
    //修改信息
    onSubmit() {
      get_user_edit(this.form).then((res) => {
        if (res["code"] === 0) {
          this.getData();
          this.$message.success(res["message"]);
        }
      });
    },
    //上传文件
    async getUpload(item) {
      return get_user_upload(item).then((res) => {
        if (res["code"] === 0) {
          this.imageUrl = res.data;
        }
      });
    },
    //上传头像
    async getImgData(item) {
      await this.getUpload(item);
      await get_user_upload_img(this.imageUrl).then((res) => {
        if (res["code"] === 0) {
          this.imageUrl = res.data;
        }
      });
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style>
.user-search {
  margin-top: 20px;
  width: 30%;
}
.up_header {
  width: 100%;
  height: 120px;
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #4382c2;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;

  margin: 0 auto;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.title_style {
  text-align: center;
}
.demo-ruleForm {
  margin-right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/user_mn/User_mn.vue